const SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS = {
  // General Config
  GETTING_COMMONS_CONFIG: 'GETTING_GENERAL_CONFIG',
  GET_COMMONS_CONFIG_SUCCESS: 'GET_GENERAL_CONFIG_SUCCESS',
  GET_COMMONS_CONFIG_FAILURE: 'GET_GENERAL_CONFIG_FAILURE',

  // Client Management Actions
  GETTING_CLIENTS: 'GETTING_CLIENTS',
  GET_CLIENTS_SUCCESS: 'GET_CLIENTS_SUCCESS',
  GET_CLIENTS_FAILURE: 'GET_CLIENTS_FAILURE',
  RESET_CLIENTS_DATA: 'RESET_CLIENTS_DATA',
  
  GETTING_CLIENT_DETAILS: 'GETTING_CLIENT_DETAILS',
  GET_CLIENT_DETAILS_SUCCESS: 'GET_CLIENT_DETAILS_SUCCESS',
  GET_CLIENT_DETAILS_FAILURE: 'GET_CLIENT_DETAILS_FAILURE',
  RESET_CLIENT_DETAILS_DATA: 'RESET_CLIENT_DETAILS_DATA',

  // Ledger Management Actions
  GETTING_LEDGERS: 'GETTING_LEDGERS',
  GET_LEDGERS_SUCCESS: 'GET_LEDGERS_SUCCESS',
  GET_LEDGERS_FAILURE: 'GET_LEDGERS_FAILURE',
  RESET_LEDGERS_DATA: 'RESET_LEDGERS_DATA',
  
  GETTING_LEDGER_DETAILS: 'GETTING_LEDGER_DETAILS',
  GET_LEDGER_DETAILS_SUCCESS: 'GET_LEDGER_DETAILS_SUCCESS',
  GET_LEDGER_DETAILS_FAILURE: 'GET_LEDGER_DETAILS_FAILURE',
  RESET_LEDGER_DETAILS_DATA: 'RESET_LEDGER_DETAILS_DATA',

  // Account Operations Actions
  GETTING_ACCOUNTS: 'GETTING_ACCOUNTS',
  GET_ACCOUNTS_SUCCESS: 'GET_ACCOUNTS_SUCCESS',
  GET_ACCOUNTS_FAILURE: 'GET_ACCOUNTS_FAILURE',
  RESET_ACCOUNTS_DATA: 'RESET_ACCOUNTS_DATA',
  
  GETTING_ACCOUNT_DETAILS: 'GETTING_ACCOUNT_DETAILS',
  GET_ACCOUNT_DETAILS_SUCCESS: 'GET_ACCOUNT_DETAILS_SUCCESS',
  GET_ACCOUNT_DETAILS_FAILURE: 'GET_ACCOUNT_DETAILS_FAILURE',
  RESET_ACCOUNT_DETAILS_DATA: 'RESET_ACCOUNT_DETAILS_DATA',
};

export default SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS; 